// Instagram Configuration for Local Development
// This file is gitignored - add your token here for local testing
// DO NOT commit this file with a real token!

window.INSTAGRAM_LOCAL_CONFIG = {
  // Paste your Instagram access token here for local development
  accessToken: ''
};
